import { RectIcon } from '@/components/IconButton';
import { ANALYTICS_EVENT_OBJECT } from '@/constants/analytics';
import { ToolBarDropdownButton } from '@/next/components/ToolBarDropdownButton';
import { useExplore } from '@/stores/explore';
import { startDraw2D, startDrawRect2D, stopDraw2D, useViewer } from '@/stores/viewer';
import { cn } from '@skand/ui';
import { useState } from 'react';
import { DrawDropdownIcon } from './DrawDropdownIcon';

export const DrawToolMenu = () => {
  const targetPhoto = useViewer(state => state.targetPhoto);
  const enabledDraw2D = useViewer(state => state.enabledDraw2D);
  const enabledDraw3D = useViewer(state => state.enabledDraw3D);
  const annotationDraft = useExplore(state => state.annotationDraft);

  const [enabledDropdown, setEnabledDropdown] = useState(false);

  const toggleFreeDrawTool = () => {
    setEnabledDropdown(false);
    if (enabledDraw2D !== 'free') {
      startDraw2D();
    } else {
      stopDraw2D();
    }
  };

  const toggleRectDrawTool = () => {
    setEnabledDropdown(false);
    if (enabledDraw2D !== 'rect') {
      startDrawRect2D();
    } else {
      stopDraw2D();
    }
  };

  return (
    <>
      {targetPhoto?.type !== 'panorama' && (
        <ToolBarDropdownButton
          analyticsEventObject={ANALYTICS_EVENT_OBJECT.DRAW_TOOL_2D}
          icon={<DrawDropdownIcon />}
          isActive={enabledDropdown ? 'dark' : enabledDraw2D !== null ? true : false}
          isDisabled={
            targetPhoto === null ||
            enabledDraw3D !== null ||
            annotationDraft?.annotation2d !== undefined
          }
          onClick={() => setEnabledDropdown(prev => !prev)}
          tooltip="Draw tools"
        />
      )}

      {enabledDropdown && (
        <div className="absolute flex flex-col">
          <div
            className={cn(
              'w-40px',
              'h-30px',
              'rounded-tr-1',
              'rounded-tl-1',
              'border-1 border-solid',
              'flex',
              'items-center',
              'justify-around',
              'border-neutral-100',
              'hover:bg-primary-500',
              enabledDraw2D === 'free' && 'bg-primary-400',
              'transition-colors',
              'cursor-pointer',
            )}
            onClick={toggleFreeDrawTool}
          >
            <div className="i-skand-annotation" />
          </div>
          <div
            className={cn(
              'w-40px',
              'h-30px',
              'rounded-br-1',
              'rounded-bl-1',
              'border-x-1 border-t-0 border-b-1 border-solid',
              'flex',
              'items-center',
              'justify-around',
              'border-neutral-100',
              'hover:bg-primary-500',
              enabledDraw2D === 'rect' && 'bg-primary-400',
              'transition-colors',
              'cursor-pointer',
            )}
            onClick={toggleRectDrawTool}
          >
            <RectIcon />
          </div>
        </div>
      )}
    </>
  );
};
